import React from 'react'
import * as service from './service'
import { updateCookie, getCookie } from '../../helpers/utility'
import { store } from 'react-notifications-component'
import { loadStripe } from '@stripe/stripe-js'
import config from '../../config'

function successToaster(msg) {
  store.addNotification({
    title: 'Success',
    message: msg,
    type: 'success',
    insert: 'top',
    container: 'top-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 2000
    }
  })
}

export default {
  state: {
    apiError: false,
    paymentLoading: false,
    isFetchingProceedPayment: false,
    paymentList: [],
    paymentHistoryList: [],
    businessList: [],
    cardsList: [],
    merchantId: '',
    prevPaymentData: {},
    smb_stripe_customer_id: '',
    platform_stripe_customer_id: '',
    isSaveCardConf: false,
    financingPromoMessagingResponse: {
      loading: false,
      error: undefined,
      data: null
    },
    merchantWisetackApplicationStatus: null
  },
  reducers: {
    onRequest(state) {
      return {
        ...state,
        paymentLoading: true
      }
    },
    onError(state, data) {
      if (data && (data.status === '400' || data.status === 400)) {
        if (data.errors[0].message.lastIndexOf('Your card has insufficient funds') !== -1) {
          if (data.invoiceId) {
            service.failedTransaction({
              invoiceId: data.invoiceId,
              account: data.last4,
              cardBrand: data.brand,
              tip: data.tip
            })
          }
          data.message = data.errors[0].message.split(';')[0]
        } else {
          data.message = data.errors[0].message
        }
      } else if (data && data.status === 402 && data != null && data.decline_code != null && data.message != null) {
        switch (data.decline_code) {
          case 'stolen_card':
            data.message = 'Your card has been declined.'
            break
          case 'fraudulent':
            data.message = 'Your card was declined. Please contact your issuer.'
            break
          case 'generic_decline' ||
            'authentication_required' ||
            'approve_with_id' ||
            'call_issuer' ||
            'card_not_supported' ||
            'card_velocity_exceeded' ||
            'currency_not_supported' ||
            'do_not_honor' ||
            'do_not_try_again' ||
            'duplicate_transaction' ||
            'incorrect_pin' ||
            'invalid_amount' ||
            'invalid_expiry_month' ||
            'invalid_expiry_year' ||
            'invalid_number' ||
            'invalid_pin' ||
            'issuer_not_available' ||
            'merchant_blacklist' ||
            'new_account_information_available' ||
            'no_action_taken' ||
            'not_permitted' ||
            'offline_pin_required' ||
            'online_or_offline_pin_required' ||
            'pickup_card' ||
            'pin_try_exceeded' ||
            'reenter_transaction' ||
            'restricted_card' ||
            'revocation_of_all_authorizations' ||
            'revocation_of_authorization' ||
            'security_violation' ||
            'service_not_allowed' ||
            'stop_payment_order' ||
            'testmode_decline' ||
            'transaction_not_allowed' ||
            'try_again_later' ||
            'withdrawal_count_limit_exceeded':
            data.message = 'Your card was declined. \n Please try a different card.'
            break
          case 'processing_error':
            data.message =
              'An error occurred while processing your payment. Try again later or with a different payment method.'
            break
          case 'lost_card':
            data.message = 'Your card has been declined.'
            break
          case 'invalid_cvc':
            data.message = "Your card's security code is incorrect."
            break
          case 'incorrect_zip':
            data.message = 'Your card number and postal code do not match.'
            break
          case 'incorrect_number':
            data.message = 'Your card number is invalid.'
            break
          case 'expired_card':
            data.message = 'Your card has expired.'
            break
          case 'insufficient_funds':
            data.messagge = 'Your card has insufficient funds.'
            break
          default:
            data.message = 'Some error occured'
            break
        }
      }
      let err = data && data.message ? data.message : data.error ? data.error : 'Some error occured'
      if (err.localeCompare('Required field parent user was missing!')) {
        err = 'No Payment Available'
      }
      store.addNotification({
        title: 'Error',
        message: (
          <div>
            {err.split('\n').map((i, key) => {
              return (
                <div style={{ color: 'white' }} key={key}>
                  {i}
                </div>
              )
            })}
          </div>
        ),
        type: 'danger',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 2000
        }
      })
      return {
        ...state,
        paymentLoading: false,
        apiError: err
      }
    },

    onGetInoivceListSuccess(state, data) {
      let oldList = state.paymentList ? state.paymentList : []
      if (oldList && oldList.length && data.data.docs && data.data.docs.length) {
        if (oldList[0].parent_user !== data.data.docs[0].parent_user) {
          oldList = []
        }
      }
      return {
        ...state,
        paymentLoading: false,
        paymentList:
          data && data.data && data.data.docs && data.data.docs.length ? [...oldList, ...data.data.docs] : [],
        paymentListTotal: data.data.total
      }
    },
    onGetHistoryInvoiceListSuccess(state, data) {
      let oldList = state.paymentHistoryList ? state.paymentHistoryList : []
      if (oldList && oldList.length && data.data.docs && data.data.docs.length) {
        if (oldList[0].user !== data.data.docs[0].user) {
          oldList = []
        }
      }

      return {
        ...state,
        paymentLoading: false,
        paymentHistoryList:
          data && data.data && data.data.docs && data.data.docs.length ? [...oldList, ...data.data.docs] : [],
        paymentHistoryTotal: data.data.total
      }
    },
    updatedHistoryInvoiceListSuccess(state, data) {
      return {
        ...state,
        paymentLoading: false,
        paymentHistoryList: data && data.data && data.data.docs,
        paymentHistoryTotal: data.data.total
      }
    },
    updatedInvoiceListSuccess(state, data) {
      return {
        ...state,
        paymentLoading: false,
        paymentList: data && data.data && data.data.docs,
        paymentListTotal: data.data.total
      }
    },
    onGetAllCardsSuccess(state, data) {
      let defaultCard = {}
      if (data && data.data) {
        data.data.forEach((element) => {
          if (element.defaultacct && element.defaultacct === 'Y') {
            defaultCard = element
          }
        })
      }
      return {
        ...state,
        paymentLoading: false,
        cardsList: data && data.data,
        defaultCard: defaultCard
      }
    },
    onGetAllStripeCardsSuccess(state, data) {
      let defaultCard = {}
      let count = 0
      if (data && data.items) {
        data.items.forEach((element) => {
          count++
          if (count === 1) {
            defaultCard = element
            element.defaultCard = true
          }
        })
      }
      return {
        ...state,
        paymentLoading: false,
        cardsList: data && data.items,
        defaultCard: defaultCard
      }
    },
    onGetSMBStripeCustomerID(state, data) {
      const smb_stripe_customer_id = data && data.data && data.data.smb_customer_id
      console.log('SMB_Stripe_Customer_ID = ' + smb_stripe_customer_id)
      return {
        ...state,
        smb_stripe_customer_id,
        paymentLoading: false
      }
    },
    setSaveCardFlag(state, data) {
      const isSaveCardConf = data
      return {
        ...state,
        isSaveCardConf
      }
    },
    onGetPlatformCustomerId(state, data) {
      const platform_stripe_customer_id = data && data.data && data.data.platform_customer_id
      console.log('SMB_Platform_Customer_ID = ' + platform_stripe_customer_id)
      return {
        ...state,
        platform_stripe_customer_id,
        paymentLoading: false
      }
    },
    onSuccess(state, data, msg) {
      store.addNotification({
        title: 'Success',
        message: data && data.message ? data && data.message : msg,
        type: 'success',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 2000
        }
      })
      return {
        ...state,
        paymentLoading: false
      }
    },
    onGetBusinessListSuccess(state, data) {
      if (data && data.data && data.data.length) {
        updateCookie({ business_name: data.data[0].business_name })
      }
      return {
        ...state,
        paymentLoading: false,
        businessList: data && data.data
      }
    },
    offlineActivitySuccess(state, data) {
      return {
        ...state,
        paymentLoading: false
      }
    },
    getUserPaymentTypeSuccess(state, data) {
      return {
        ...state,
        paymentLoading: false,
        businessPaymentType: data && data.data && data.data.payment_type ? data.data.payment_type : '',
        achPaymentStatus: data && data.data && data.data.achPayment ? data.data.achPayment : false,
        businessPaymentTip: data && data.data ? data.data.isAllowTip : ''
      }
    },
    onGetMerchantIdSuccess(state, data) {
      const merchantId = data && data.merchantId ? data.merchantId : null
      return {
        ...state,
        merchantId,
        paymentLoading: false
      }
    },
    onAddCardSuccess(state, data) {
      successToaster('Card added successfully')
      if (data && data.data.userData) {
        updateCookie({ userData: data.data.userData })
      }
      return {
        ...state,
        paymentLoading: false,
        userData: getCookie()
      }
    },
    onPaymentSuccess(state, data) {
      const paymentHistoryList = state.paymentHistoryList
      let paymentHistoryTotal = state.paymentHistoryTotal
      let platform_stripe_customer_id = null
      if (data && data.data && data.data.paymentDetails) {
        data.data.paymentDetails.id = data.data.paymentDetails._id
        if (!data.data.paymentDetails.orderid && data.data.paymentData.orderid) {
          data.data.paymentDetails.orderid = data.data.paymentData.orderid
        }
        paymentHistoryList.unshift(data.data.paymentDetails)
        paymentHistoryTotal = paymentHistoryTotal + 1
      }
      if (data && data.data.userData) {
        updateCookie({ userData: data.data.userData })
        if (data.data.userData.platform_customer_id) {
          platform_stripe_customer_id = data.data.userData.platform_customer_id
        }
      }
      return {
        ...state,
        paymentLoading: false,
        userData: getCookie(),
        paymentHistoryList,
        paymentHistoryTotal,
        platform_stripe_customer_id
      }
    },
    onRemoveCardSuccess(state, data) {
      successToaster(data.data && data.data.message ? data.data.message : 'Card deleted successfully')
      let oldList = state.cardsList
      if (data && data.data && data.data.userData) {
        updateCookie({ userData: data.data.userData })
        if (data.data.userData.cardConnectId === null) {
          oldList = []
        }
      }
      return {
        ...state,
        paymentLoading: false,
        userData: getCookie(),
        cardsList: [...oldList]
      }
    },
    getSuccessPaymentReceipt(state, data) {
      const paymentHistoryList = state.paymentHistoryList
      if (paymentHistoryList && paymentHistoryList.length && !paymentHistoryList[0].invoice_url) {
        paymentHistoryList[0].invoice_url = data.data
      }

      return {
        ...state,
        paymentLoading: false,
        paymentHistoryList
      }
    },
    onDefaultStripeCardUpdated(state, data) {
      const defaultCard = data
      return {
        ...state,
        paymentLoading: false,
        defaultCard: defaultCard
      }
    },
    onDefaultCardUpdated(state, data) {
      let defaultCard
      const updatedCards = []
      if (data && data.data && data.data.acctid) {
        const allCards = [...state.cardsList]
        allCards.forEach((card) => {
          if (card.acctid === data.data.acctid) {
            defaultCard = card
            card.defaultacct = 'Y'
            updatedCards.push(card)
          } else {
            card.defaultacct = 'N'
            updatedCards.push(card)
          }
        })
      }
      return {
        ...state,
        paymentLoading: false,
        defaultCard: defaultCard,
        cardsList: updatedCards
      }
    },
    async clearAll(state, data) {
      localStorage.removeItem('businessData')
      return {
        paymentLoading: false
      }
    },
    getSuccessGetInoivceById(state, invoiceData) {
      const oldList = state.paymentList ? state.paymentList : []
      const { data } = invoiceData
      if (data.invoice_status && ['open', 'due', 'pending', 'declined'].indexOf(data.invoice_status) > -1)
        oldList.unshift(data)

      return {
        ...state,
        paymentLoading: false,
        paymentList: oldList
      }
    },
    setIsFetchingProceedPayment(state, isFetchingProceedPayment = false) {
      return { ...state, isFetchingProceedPayment }
    },
    getSuccessGetBusinessType(state, data) {
      return {
        ...state,
        paymentLoading: false,
        bussinessTypes: data
      }
    },
    onGetBusinessOwnerInfoSuccess(state, data) {
      return {
        ...state,
        paymentLoading: false
      }
    },
    ongetPlaidAccessTokenSuccess(state, data) {
      return {
        ...state,
        bussinessDetailsloading: false,
        plaidToken: data.data
      }
    },
    onGetBankingSuccess(state, data) {
      return {
        ...state,
        bussinessDetailsloading: false,
        bankingdata: data.data
      }
    },
    onGetAchTokenSuccess(state, data) {
      return {
        ...state,
        achToken: data
      }
    },
    onClearCardList(state, data) {
      return {
        ...state,
        cardsList: []
      }
    },
    storePaymentDetails(state, data) {
      return {
        ...state,
        prevPaymentData: data
      }
    },
    onBeforeGetFinancingPromoMessaging(state) {
      return {
        ...state,
        financingPromoMessagingResponse: {
          data: null,
          error: undefined,
          loading: true
        }
      }
    },
    onGetFinancingPromoMessagingError(state, error) {
      return {
        ...state,
        financingPromoMessagingResponse: {
          data: null,
          error: error,
          loading: false
        }
      }
    },
    onGetFinancingPromoMessagingSuccess(state, data) {
      return {
        ...state,
        financingPromoMessagingResponse: {
          data: data,
          error: undefined,
          loading: false
        }
      }
    },
    onGetMerchantWisetackApplicationStatusSuccess(state, data) {
      return {
        ...state,
        merchantWisetackApplicationStatus: data
      }
    },
    onGetMerchantWisetackApplicationStatusError(state, error) {
      return {
        ...state,
        merchantWisetackApplicationStatus: null
      }
    }
  },
  effects: {
    async getInoivceList(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getInoivceList(payload)
        this.onGetInoivceListSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getHistoryInvoiceList(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getPaymentList(payload)
        this.onGetHistoryInvoiceListSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getAllCards(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getAllCards(payload)
        this.onGetAllCardsSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getConfigFlag(isSaveCard) {
      this.setSaveCardFlag(isSaveCard)
    },
    async getAllStripeCards(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getAllStripeCards(payload)
        this.onGetAllStripeCardsSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getSMBStripeCustomerID(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getSMBStripeCustomerID(payload)
        this.onGetSMBStripeCustomerID(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getPlatformCustomerId(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getPlatformCustomerId(payload)
        this.onGetPlatformCustomerId(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async addCard(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.addCard(payload)
        this.onAddCardSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async setDefaultCard(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.setDefaultCard(payload)
        // this.onSuccess(res,"Default card updated")
        this.onDefaultCardUpdated(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async changeDefaultStripeCard(payload) {
      this.onDefaultStripeCardUpdated(payload)
      return payload
    },
    async proceedPayment(payload, rootState) {
      try {
        this.setIsFetchingProceedPayment(true)
        let res
        if (payload.stripeBankAccessToken) {
          //stripe bank transfer
          res = await service.stripeACHPayment(payload)
          res = res.items
        } else {
          // CCN bank transfer
          res = await service.proceedPayment(payload)
        }
        this.onPaymentSuccess(res)
        const { data = {} } = res
        const { paymentData = {} } = data
        const { parent_user = '', invoice_status = '', invoice_amount = 0, tip = 0 } = paymentData
        await service.trackTransactionStatusChange({
          userId: parent_user,
          status: invoice_status,
          amount: invoice_amount,
          tip
        })
        return res
      } catch (e) {
        this.onError(e)
      } finally {
        this.setIsFetchingProceedPayment(false)
      }
    },
    async proceedStripePayment(payload, rootState) {
      let stripeObj
      try {
        this.setIsFetchingProceedPayment(true)
        const {
          stripeObject: { LpaymentMethod, savedCardCheck }
        } = payload
        stripeObj = payload.stripeObject
        delete payload.stripeObject
        payload.parentUser = payload.parent_user
        payload.invoiceSource = payload.invoice_source
        payload.inputSource = 'endUserDashboard'
        payload.paymentTransactionType = payload.payment_transaction_type
        delete payload.parent_user
        delete payload.invoice_source
        delete payload.payment_transaction_type
        const merchantStripe = await loadStripe(config.stripe_pk, {
          stripeAccount: payload.merchantId
        })
        // Option C (identity design/09): the pm already exists here — sending its id lets the
        // server corroborate the payer's identity (phone + card fingerprint) BEFORE choosing a
        // Stripe customer. Absent for saved-card payments; the server ignores a missing value.
        payload.paymentMethodId = LpaymentMethod && LpaymentMethod.id
        const clientSecret = await service.getPaymentIntent(payload)
        let response
        if (payload.saveCardFlag && savedCardCheck) {
          response = await merchantStripe.confirmCardPayment(clientSecret.items.clientSecret)
        } else {
          response = await merchantStripe.confirmCardPayment(clientSecret.items.clientSecret, {
            payment_method: LpaymentMethod.id
          })
        }
        const paymentIntent = response.paymentIntent
        const error = response.error

        if (error) {
          const postPayload = {
            paymentIntentId: error.payment_intent.id,
            merchantId: payload.merchantId,
            inputSource: 'endUserDashboard'
          }
          try {
            await service.proceedPostStripePayment(postPayload)
          } catch {}
          throw error
        }
        const postPayload = {
          paymentIntentId: paymentIntent.id,
          merchantId: payload.merchantId,
          inputSource: 'endUserDashboard'
        }
        const res = await service.proceedPostStripePayment(postPayload)
        this.onPaymentSuccess(res.items)
        const { data = {} } = res.items
        const { paymentData = {} } = data
        const { parent_user = '', invoice_status = '', invoice_amount = 0, tip = 0 } = paymentData
        await service.trackTransactionStatusChange({
          userId: parent_user,
          status: invoice_status,
          amount: invoice_amount,
          tip
        })
        return res
      } catch (e) {
        console.log(payload, stripeObj)
        e.invoiceId = payload.invoiceId
        e.tip = payload.tip
        if (stripeObj && stripeObj.LpaymentMethod && stripeObj.LpaymentMethod.card) {
          e.last4 = stripeObj.LpaymentMethod.card.last4 || stripeObj.LpaymentMethod.card.lastFourDigit
          e.brand = stripeObj.LpaymentMethod.card.brand
        }
        this.onError(e)
      } finally {
        this.setIsFetchingProceedPayment(false)
      }
    },
    async removeCard(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.removeCard(payload)
        this.onRemoveCardSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async removeStripeCard(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.removeStripeCard(payload)
        this.onRemoveCardSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async updatedHistoryInvoiceList(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getPaymentList(payload)
        this.updatedHistoryInvoiceListSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async updatedInvoiceList(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getInoivceList(payload)
        this.updatedInvoiceListSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async addPaymentTip(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.addPaymentTip(payload)
        this.onSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async handleEditCardconnectCard(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.handleEditCardconnectCard(payload)
        this.onSuccess(res, 'Card info updated')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getBusinessList(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getBusinessList(payload)
        this.onGetBusinessListSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async offlineActivity(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.offlineActivity(payload)
        this.offlineActivitySuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getUserPaymentType(payload, state) {
      this.onRequest()
      try {
        const res = await service.getUserPaymentType(payload)
        this.getUserPaymentTypeSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getPaymentReceipt(payload, state) {
      this.onRequest()
      try {
        const res = await service.getPaymentReceipt(payload)
        this.getSuccessPaymentReceipt(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async clearAlldata(payload, rootState) {
      this.clearAll()
    },
    async getInoivceById(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getInoivceById(payload)
        this.getSuccessGetInoivceById(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getMerchantId(payload) {
      this.onRequest()
      try {
        const res = await service.getMerchantId(payload)
        this.onGetMerchantIdSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    /**
     * fetch the rest of the tracking properties through getBusinesOwnerInfo
     * @returns
     *  "company_id", "business_name", "role", "created_at", "mcc_code", "business_category", business_email_address
     */
    async getBusinessOwnerInfo(payload) {
      this.onRequest()
      try {
        const res = await service.getBusinessOwnerInfo(payload)
        this.onGetBusinessOwnerInfoSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getBusinessType() {
      this.onRequest()
      try {
        const res = await service.getBusinessType()
        this.getSuccessGetBusinessType(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getACHConfFlag(payload) {
      try {
        const res = await service.getACHConfFlag(payload)
        this.getSuccessGetBusinessType(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getFeatureFlags(payload) {
      try {
        const res = await service.getFeatureFlags(payload)
        this.getSuccessGetBusinessType(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getPlaidAccessToken(payload, rootState) {
      try {
        const res = await service.getPlaidAccessToken(payload)
        await this.ongetPlaidAccessTokenSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getBanking(payload, rootState) {
      try {
        const res = await service.getBanking(payload)
        await this.onGetBankingSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getAchToken(payload, rootState) {
      try {
        const res = await service.getAchToken(payload)
        await this.onGetAchTokenSuccess(res)
        return res
      } catch {}
    },
    async clearCardList() {
      try {
        await this.onClearCardList()
      } catch {}
    },
    async storePaymentInfo(payload, rootState) {
      try {
        this.storePaymentDetails(payload)
        return
      } catch {}
    },
    async createWisetackTransactionForInvoice(invoiceId, rootState) {
      try {
        return await service.createWisetackTransactionForInvoice(invoiceId)
      } catch (err) {
        this.onError(err)
      }
    },
    async getPromotionalDetailsForInvoice(invoiceId, rootState) {
      this.onBeforeGetFinancingPromoMessaging()
      try {
        const result = await service.getPromotionalDetailsForInvoice(invoiceId)
        this.onGetFinancingPromoMessagingSuccess(result)
        return result
      } catch (err) {
        this.onGetFinancingPromoMessagingError(err)
      }
    },
    async getMerchantWisetackApplicationStatus(invoiceId, rootState) {
      try {
        const result = await service.getMerchantWisetackApplicationStatus(invoiceId)
        this.onGetMerchantWisetackApplicationStatusSuccess(result)
        return result
      } catch (err) {
        this.onGetMerchantWisetackApplicationStatusError(err)
        this.onError(err)
      }
    }
  }
}
